import { APIClient } from '@frontend/api-utils';

export class NotificationTemplatePlaceholderClient extends APIClient {
    public static readonly endpoint = '/notification-api/v1';

    public static async fetchPlaceholders(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/placeholders`);
        return await this.handleResponse<string[]>(response);
    }
}
